import { faGithub, faLinkedinIn, faYoutube } from "@fortawesome/free-brands-svg-icons";

export const SOCIAL_LINKS = [
  { icon: faGithub, href: "https://www.github.com/nicholas-tao" },
  { icon: faLinkedinIn, href: "https://www.linkedin.com/in/nicholastao" },
  { icon: faYoutube, href: "https://www.youtube.com/@nicholast" },
] as const;
